// utils > Color
type RGBA = [number, number, number, number]

const colorNames = {
	aquamarine: '7FFFD4',
	crimson: 'DC143C',
	papayawhip: 'FFEFD5',
	plum: 'DDA0DD'
}

const isValidHex = (hex: string) => /^#([A-Fa-f0-9]{3,4}){1,2}$/.test(hex)

const getChunksFromString = (st: string, chunkSize: number) => st.match(new RegExp(`.{${chunkSize}}`, 'g'))

const convertHexUnitTo256 = (hexStr: string) => parseInt(hexStr.repeat(2 / hexStr.length), 16)

const getAlphafloat = (a?: number, alpha?: number) => {
	if (typeof a !== 'undefined') {
		return a
	}

	if (typeof alpha !== 'undefined') {
		if (1 < alpha && alpha <= 100) {
			return alpha / 100
		}
		if (0 <= alpha && alpha <= 1) {
			return alpha
		}
	}
	return 1
}

export const colorNameToRGBA = (colorName: string): RGBA => {
	const result = colorNames[colorName]

	if (!result) throw new Error(`CSS color not found: ${colorName}`)

	return hexToRGBA(`#${result}`)
}

export const hexToRGBAString = (hex: string, alpha?: number) => RGBAArrayToCssString(hexToRGBA(hex), alpha)
export const hexToRGBA = (hex: string): RGBA => {
	if (!isValidHex(hex)) {
		throw new Error('Invalid HEX')
	}

	const chunkSize = Math.floor((hex.length - 1) / 3)
	const hexArr = getChunksFromString(hex.slice(1), chunkSize)

	if (!hexArr) throw new Error('Failed to create hexArr')

	return hexArr.map(convertHexUnitTo256) as RGBA
}

export const RGBAArrayToCssString = ([r, g, b, a]: RGBA, alpha?: number) => {
	return `rgba(${r}, ${g}, ${b}, ${getAlphafloat(a, alpha)})`
}

export const blend = (...args: RGBA[]): RGBA => {
	let mix: RGBA = args[0]
	let toMixIn: RGBA | undefined

	while ((toMixIn = args.shift())) {
		if (typeof toMixIn[3] === 'undefined') {
			toMixIn[3] = 1
		}

		if (mix[3] && toMixIn[3]) {
			// alpha
			mix[3] = (mix[3] + toMixIn[3]) / 2
			// red
			mix[0] = Math.round((mix[0] + toMixIn[0]) / 2)
			// green
			mix[1] = Math.round((mix[1] + toMixIn[1]) / 2)
			// blue
			mix[2] = Math.round((mix[2] + toMixIn[2]) / 2)
		} else if (!mix[3]) {
			mix = toMixIn
		}
	}

	return mix || [0, 0, 0, 0]
}
